export const DBConfig = {
    name: "EquipmentInspection",
    version: 5,
    objectStoresMeta: [
        {
            store: "media",
            storeConfig: { keyPath: "id", autoIncrement: true },
            storeSchema: [
                { name: "name", keypath: "name", options: { unique: false } },
                { name: "file", keypath: "file", options: { unique: false } },
                { name: "question", keypath: "question", options: { unique: false } },
                { name: "formId", keypath: "formId", options: { unique: false } },
            ],
        },
        {
            store: "signature",
            storeConfig: { keyPath: "id", autoIncrement: false },
            storeSchema: [
                { name: "signatureData", keypath: "signatureData", options: { unique: false } },
                { name: "equipmentId", keypath: "equipmentId", options: { unique: false } },
                { name: "unitId", keypath: "unitId", options: { unique: false } },
                { name: "equipmentName", keypath: "equipmentName", options: { unique: false } },
            ],
        },
    ],
};
